import { render } from "./ApplicationItemsSummary.vue?vue&type=template&id=45f613d9"
import script from "./ApplicationItemsSummary.vue?vue&type=script&lang=js"
export * from "./ApplicationItemsSummary.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ApplicationItemsSummary.vue?vue&type=style&index=0&id=45f613d9&lang=module.css&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__